import { reactive } from 'vue'
import { apiPost } from '@/composables/useApi'
import { auth } from '@/firebase'

// 模块级别的共享状态（单例）：当前用户单词本里的单词和原形，用于字幕高亮
const savedWords = reactive(new Set())
let loadedUid = ''
let loadingPromise = null

const normalize = (value) => String(value || '').trim().toLowerCase()

export async function loadSavedVocabulary() {
  const uid = auth.currentUser?.uid || ''
  if (!uid) {
    savedWords.clear()
    loadedUid = ''
    return
  }
  if (uid === loadedUid) return
  if (loadingPromise) return loadingPromise

  loadingPromise = apiPost('/api/vocabulary/words', {})
    .then((result) => {
      savedWords.clear()
      ;(result.words || []).forEach((word) => savedWords.add(normalize(word)))
      loadedUid = uid
    })
    .finally(() => {
      loadingPromise = null
    })
  return loadingPromise
}

export function markVocabularySaved(...words) {
  words.map(normalize).filter(Boolean).forEach((word) => savedWords.add(word))
}

export function invalidateSavedVocabulary() {
  loadedUid = ''
}

export function isVocabularySaved(word) {
  return savedWords.has(normalize(word))
}
